import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import TemplateTask from '../../entities/templateTask';
import CaseTypeStage from '../../entities/caseTypeStage';
import Task from '../../entities/task';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteTemplateTask(): boolean {
return true;
}
export function collectTemplateTaskDeleteImpact(templateTask: TemplateTask, context: DeleteImpactContext): void {
const key = 'templateTask:' + templateTask.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const caseTypeStageTemplateTaskIdsImpact = workingRows<CaseTypeStage>('caseTypeStage', findAll<CaseTypeStage>('caseTypeStages')).filter(caseTypeStageRef => caseTypeStageRef.templateTaskIds?.includes(templateTask.id));
caseTypeStageTemplateTaskIdsImpact.forEach(caseTypeStageRef => addDeleteImpact(context, 'caseTypeStage:' + caseTypeStageRef.id, 'caseTypeStages'));
const taskFromTemplateIdImpact = workingRows<Task>('task', findAll<Task>('tasks')).filter(taskRef => taskRef.fromTemplateId === templateTask.id);
taskFromTemplateIdImpact.forEach(taskRef => addDeleteImpact(context, 'task:' + taskRef.id, 'tasks'));}
export function deleteImpactTemplateTask(templateTask: TemplateTask): DeleteImpact {
const context = deleteImpactContext();
collectTemplateTaskDeleteImpact(templateTask, context);
return deleteImpactCounts(context);
}
export function deleteTemplateTask(templateTask: TemplateTask, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteTemplateTask()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectTemplateTaskDeleteImpact(templateTask, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || templateTask.id};
}
const key = 'templateTask:' + templateTask.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<CaseTypeStage>('caseTypeStage', [...store.getState().caseTypeStages.getMappingFor('templateTaskIds', templateTask.id)]).filter(caseTypeStageTemp => caseTypeStageTemp.templateTaskIds?.includes(templateTask.id)).forEach(caseTypeStageTemp => {
const _caseTypeStage = ((_work.get('caseTypeStage:' + caseTypeStageTemp.id) ?? caseTypeStageTemp) as CaseTypeStage).clone();
if (_caseTypeStage.status === 'D') return;
_caseTypeStage.status = 'U';
_caseTypeStage.addedOn = newHRTimestamp();
_caseTypeStage.addedBy = getCurrentUserId();
_caseTypeStage.importSource = targetImportSource;
_caseTypeStage.importId = mergeId;
_caseTypeStage.templateTaskIds = _caseTypeStage.templateTaskIds?.filter(id => id !== templateTask.id) || [];

_work.set('caseTypeStage:' + _caseTypeStage.id, _caseTypeStage);
dispatch(Actions.CaseTypeStageActions.saveCaseTypeStageQueue(_caseTypeStage), 'caseTypeStage:' + _caseTypeStage.id);
});
workingRows<Task>('task', [...store.getState().tasks.getMappingFor('fromTemplateId', templateTask.id)]).filter(taskTemp => taskTemp.fromTemplateId === templateTask.id).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
if (_task.status === 'D') return;
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.fromTemplateId === templateTask.id) {
_task.fromTemplateId = null;

}
_work.set('task:' + _task.id, _task);
dispatch(Actions.TaskActions.saveTaskQueue(_task), 'task:' + _task.id);
});
const deleted = templateTask.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.TemplateTaskActions.removeTemplateTaskQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceTemplateTask(templateTask: TemplateTask, replaceWith: TemplateTask, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = templateTask.id;}
const _work = workingSet();
workingRows<CaseTypeStage>('caseTypeStage', [...store.getState().caseTypeStages.getMappingFor('templateTaskIds', templateTask.id)]).filter(caseTypeStageTemp => caseTypeStageTemp.templateTaskIds?.includes(templateTask.id)).forEach(caseTypeStageTemp => {
const _caseTypeStage = ((_work.get('caseTypeStage:' + caseTypeStageTemp.id) ?? caseTypeStageTemp) as CaseTypeStage).clone();
if (_caseTypeStage.status === 'D') return;
_caseTypeStage.status = 'U';
_caseTypeStage.addedOn = newHRTimestamp();
_caseTypeStage.addedBy = getCurrentUserId();
_caseTypeStage.importSource = targetImportSource;
_caseTypeStage.importId = mergeId;
_caseTypeStage.templateTaskIds = _caseTypeStage.templateTaskIds?.map(id => (id === templateTask.id) ? replaceWith.id : id) || [];

_work.set('caseTypeStage:' + _caseTypeStage.id, _caseTypeStage);
store.dispatch(Actions.CaseTypeStageActions.saveCaseTypeStageQueue(_caseTypeStage));
});
workingRows<Task>('task', [...store.getState().tasks.getMappingFor('fromTemplateId', templateTask.id)]).filter(taskTemp => taskTemp.fromTemplateId === templateTask.id).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
if (_task.status === 'D') return;
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.fromTemplateId === templateTask.id) {
_task.fromTemplateId = replaceWith.id;

}
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});



return templateTask;
}
